<template>
  <!-- ---------------------------------- 企业资讯详情 ---------------------------------- -->
  <div class="infor_main">
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Header></Header>
    <!-- ---------------------------------- 资讯详情 ---------------------------------- -->
    <div class="mains">
      <!-- 标题 -->
      <div class="mains_title">企业资讯</div>
      <!-- 内容 -->
      <div class="mains_content">
        <!-- 日期、标题 -->
        <div class="content_title">
          <!-- 日期 -->
          <div>
            <div class="date">
              <p>{{content[0].createTime.toString().substring(8)}}</p>
              <span>{{content[0].backup2}}</span>
            </div>
            <div class="years">{{content[0].backup1}}</div>
          </div>
          <!-- 标题 -->
          <div class="title">{{content[0].title}}</div>
        </div>
        <!-- 文字 -->
        <div class="content_text">

          <div class="text">
              <!--            <img :src="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+pic[0]" alt="">-->
              <img v-lazy="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+pic[0]" alt="" >
              <span v-html="content[0].content" class="text_wrapper">
            </span>
          </div>

        </div>

    <div style="display:flex">
  		<!-- 分页 -->
		   <div class="pagingtop" @click="online">
         	<div class="left_white">
		         <img src="../assets/images/icon/left-white.png" alt="">
		       </div>

		       <span >上一篇</span>
		     </div>


        <div class="paging" @click="down">
		       <span v-if="pagenumber!=2">下一篇</span>
            <span v-if="pagenumber==2">最后一页</span>
		       <div class="right_white">
		         <img src="../assets/images/icon/right-white.png" alt="">
		       </div>
		    </div>
  </div>


      </div>
    </div>
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer';
  import Axios from "axios";
  export default {
    components:{
      Header,
      Footer,
    },
    data (){
      return{
        id: undefined,
        content: [],
        pic: [],
        pagenumber:0
      }
    },
    created(data) {
      var str = window.location.toString()
      this.id = str.split('=')[1]
      this.getContent(this.id)
      this.tiaoZhuan();
    },
    methods: {
      down(){
        if(this.id == 11){
          this.$message.info('已经是最后一篇了',2);
          return
        }
        this.$router.push({
            path: '/information_main?id='+11
        });
        this.$router.go(0)
      },
      online(){
        if(this.id == 45){
          this.$message.info('已经是第一篇了',2);
          return
        }
        this.$router.push({
            path: '/information_main?id='+45
        });
        this.$router.go(0)
      },


      tiaoZhuan(){
        let setId = this.$route.query.setId;
        if (setId === undefined){
          return
        }else {
          this.getContent(setId);
        }
      },
      getContent(id){
        var that = this;
        var pic = [];
        var url = "http://118.89.87.102:8080/jeecg-boot/rule/information/list?id="+id;
        // var url = "http://192.168.71.1:8082/jeecg-boot/rule/information/list?id="+id;
        Axios.get(url).then(res =>{
          if (res.data.success === true){
            that.content.push(res.data.result.records[0]);
            for (let i = 0; i < res.data.result.records[0].cover.toString().split(",").length; i++) {
              that.pic.push(res.data.result.records[0].cover.toString().split(",")[i])
            }

          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .text_wrapper{
    font-size: 0.04167rem;
    color: #595857;
    width: 1000px;
    overflow: hidden;
    float: left;
    text-overflow: ellipsis;
    white-space: normal;
    width: 100%;
	/* p{
		width: 200px !important;
		height: 200px !important;
	}
	img{

	} */
  }

  // ------------- mobile端样式 -------------
  @media only screen and (max-width: 960px) {   
       /* 标题 */
        .mains{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #EBF2CF;
    padding: 78px 0 85px 0;
    .mains_title{
      width: 400px;
      border-bottom: 5px solid #BCC33F;
      margin: 0 auto;
      margin-bottom: 130px;
      text-align: center;
      padding-bottom: 23px;
      font-size: 65px;
      color: #BCC33F;
      letter-spacing: 8px;
      font-weight: 600;
    }  

    }
      // 标题
        .title{
          font-size: 56px;
          color: #595757;
          margin-left: 59px;
        }
    // 分页
    .paging{
      span{ font-size: 54px;}
      .right_white{ width: 70px; height: 70px;}
    }
    .pagingtop{
      span{ font-size: 54px;}
      .left_white{ width: 70px !important; height: 70px !important;}
    }
	.text{
		/deep/ img{
			width: 100%;
			height: 700px;
		}
		/deep/ p{
			font-size: 50px;

		}
	}
	}
  // ------------- pc端样式 -------------
  @media only screen and (min-width: 960px) {     // 屏幕大于960px
    // 分页
    .paging{
      span{ font-size: 31px;}
      .right_white{ width: 50px; height: 50px;}
    }
      .mains{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #EBF2CF;
    padding: 78px 0 85px 0;
    /* 标题 */
    .mains_title{
      width: 369px;
      border-bottom: 5px solid #BCC33F;
      margin: 0 auto;
      margin-bottom: 130px;
      text-align: center;
      padding-bottom: 23px;
      font-size: 40px;
      color: #BCC33F;
      letter-spacing: 8px;
    }
      }
       // 标题
        .title{
          font-size: 45px;
          color: #595757;
          margin-left: 59px;
        }
	}
  .mains{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #EBF2CF;
    padding: 78px 0 85px 0;
    /* 标题 */
    // .mains_title{
    //   width: 369px;
    //   border-bottom: 5px solid #BCC33F;
    //   margin: 0 auto;
    //   margin-bottom: 130px;
    //   text-align: center;
    //   padding-bottom: 23px;
    //   font-size: 40px;
    //   color: #BCC33F;
    //   letter-spacing: 8px;
    // }
    // 内容
    .mains_content{
      width: 75%;
      background-color: #FFFFFF;
      padding: 31px 105px 85px 42px;
      box-sizing: border-box;
      margin: 0 auto;
      margin-bottom: 173px;
      // 日期、标题
      .content_title{
        width: 100%;
        display: flex;
        align-items: flex-end;
        // 日期
        .date{
          width: 150px;
          height: 150px;
          color: #FFFFFF;
          text-align: center;
          letter-spacing: 2px;
          background-color: #BCC33F;
          padding-top: 25px;
          p{
            font-size: 56px;
            font-weight: bold;
            margin: 0 0 12px 0;
            line-height: 1;
            width: 100%;
          }
          span{
            font-size: 25px;
            font-weight: lighter;
            line-height: 1;
            display: block;

          }
        }
        .years{
          font-size: 40px;
          color: #BCC33F;
          line-height: 1;
          margin-top: 29px;
          text-align: center;
          font-weight: bold;
        }
        // // 标题
        // .title{
        //   font-size: 48px;
        //   color: #595757;
        //   margin-left: 59px;
        // }
      }
      // 文字
      .content_text{
        width: 100%;
        display: flex;
        padding: 37px 0 0 0;
        margin-left: 4%;
        img{
          // width: 53px;
	    	  width: 100% !important;
          height: auto;
          margin-top: 230px;
          cursor: pointer;
        }
        .arrow_left{
          margin-left: 36px;
        }
        .text{
          // width: 100%;
		      width: 500px;
          flex-grow: 1;
          padding: 0 103px 0 113px;
         /deep/ img{
            width: 100% !important;
            height: auto !important;
            display: block;
            margin: 0 auto;
            margin-bottom: 49px;
          }
          span{
            font-size: 20px;
            color: #595857;
            line-height: 1.8;
          }
        } 
      }
    }
    // 分页
    .paging{
      display: flex;
      align-items: center;
      justify-content: end;
      margin: 0 auto;
      span{
        color: #888889;
      }
      .right_white{
        background-color: #888889;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        cursor: pointer;
        img{
          width: 17px;
        }
      }
    }


   // 分页
    .pagingtop{
      display: flex;
      align-items: center;
      //justify-content: end;
      margin: 0 auto;
      span{
        color: #888889;
      }
      .left_white{
        background-color: #888889;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        cursor: pointer;
        width: 0.260417rem;
        height: 0.260417rem;
        margin-right: 0.104167rem;
        color:#fff;
        img{
          width: 17px;
        }
      }
    }

  }
  @media only screen and (min-width: 1260px) {    // 屏幕150%
    // 分页
    .paging{
      span{ font-size: 31px;}
      .right_white{ width: 50px; height: 50px;}
    }

    // 分页
    .pagingtop{
      span{ font-size: 31px;}
      .left_white{ width: 50px; height: 50px;}
    }

  	}
  .mains{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #EBF2CF;
    padding: 78px 0 85px 0;
    /* 标题 */
    .mains_title{
      // width: 369px;
      // border-bottom: 5px solid #BCC33F;
      // margin: 0 auto;
      // margin-bottom: 130px;
      // text-align: center;
      // padding-bottom: 23px;
      // font-size: 40px;
      // color: #BCC33F;
      // letter-spacing: 8px;
      // font-weight: lighter;
    }
    // 内容
    .mains_content{
      width: 75%;
      background-color: #FFFFFF;
      padding: 31px 105px 85px 42px;
      box-sizing: border-box;
      margin: 0 auto;
      margin-bottom: 173px;
      // 日期、标题
      .content_title{
        width: 100%;
        display: flex;
        align-items: flex-end;
        // 日期
        .date{
          width: 150px;
          height: 150px;
          color: #FFFFFF;
          text-align: center;
          letter-spacing: 2px;
          background-color: #BCC33F;
          padding-top: 25px;
          p{
            font-size: 56px;
            font-weight: bold;
            margin: 0 0 12px 0;
            line-height: 1;
            width: 100%;
          }
          span{
            font-size: 25px;
            font-weight: lighter;
            line-height: 1;

          }
        }
        .years{
          font-size: 40px;
          color: #BCC33F;
          line-height: 1;
          margin-top: 29px;
          text-align: center;
          font-weight: bold;
        }
        // 标题
        // .title{
        //   font-size: 48px;
        //   color: #595757;
        //   margin-left: 59px;
        // }
      }
      // 文字
      .content_text{
        width: 100%;
        display: flex;
        padding: 37px 0 0 0;
        margin-left: 4%;
        img{
          // width: 53px;
  		    width: 100% !important;
          height: auto!important;
          margin-top: 230px;
          cursor: pointer;
        }
        .arrow_left{
          margin-left: 36px;
        }
        .text{
          // width: 100%;
  		  width: 500px;
          flex-grow: 1;
          padding: 0 103px 0 113px;
         /deep/ img{
            width: 100% !important;
            height: auto!important;
            display: block;
            margin: 0 auto;
            margin-bottom: 49px;
          }
          span{
            font-size: 20px;
            color: #595857;
            line-height: 1.8;
          }
        }
      }
    }
    // 分页
    .paging{
      display: flex;
      align-items: center;
      justify-content: end;
      margin: 0 auto;
      span{
        color: #888889;
      }
      .right_white{
        background-color: #888889;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        cursor: pointer;
        img{
          width: 17px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/information_main.vue